import styled, { css } from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import { desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

const setHeadingStyles = css`
  h2 {
    color: ${nuDSColor('black')};
    font-size: 1.5rem;
    line-height: 1.32;
    letter-spacing: -0.02em;
    margin: 3rem 0 1.5rem;

    ${desktop1024`
      font-size: 2.5rem;
      line-height: 1.2;
    `}
  }

  h3 {
    color: ${nuDSColor('black')};
    font-size: 1.25rem;
    line-height: 1.22;
    letter-spacing: -0.02em;
    margin: 2.5rem 0 1.25rem;

    ${desktop1024`
      font-size: 1.5rem;
      line-height: 1.32;
    `}
  }
`;

const setParagraphStyles = css`
  p,
  li {
    color: ${nuDSColor('black')};
    font-size: 1rem;
    line-height: 150%;
    letter-spacing: -0.01em;
    margin-top: 1.5rem;
  }
`;

const setLinkStyles = css`
  a {
    color: ${nuDSColor('primary')};
  }
`;

const setListStyles = css`
ul,
  ol {
    list-style: none;

    &[class*="-0"] {
      padding-left: 1rem;

      ${desktop1024`
        padding-left: 2rem;
      `}
    }

    &[class*="-1"] {
      padding-left: 2rem;

      ${desktop1024`
        padding-left: 4rem;
      `}
    }

    &[class*="-2"] {
      padding-left: 3rem;

      ${desktop1024`
        padding-left: 6rem;
      `}
    }

    &[class*="-3"] {
      padding-left: 4rem;

      ${desktop1024`
        padding-left: 8rem;
      `}
    }

    &[class*="-4"] {
      padding-left: 5rem;

      ${desktop1024`
        padding-left: 10rem;
      `}
    }
  }

  li:before {
    font-weight: bold;
  }
`;

const fixFirstElemenMargin = css`
  style + * {
    margin-top: 0;
  }
`;

export const ContractContainer = styled.article`
  ${setHeadingStyles}
  ${setParagraphStyles}
  ${setLinkStyles}
  ${setListStyles}
  ${fixFirstElemenMargin}
`;

ContractContainer.displayName = 'ContractContainer';
